module.exports = require('./lib/client/index');



//////////////////
// WEBPACK FOOTER
// ./~/feathers-rest/client.js
// module id = 859
// module chunks = 13